import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetSendOutCollectionDetailQuery, useUpdateSendOutCollectionMutation } from "store/services/sendOutCollectionApi"; 
import SendOutCollectionForm from "./SendOutCollectionComponent/SendOutCollectionForm"; 

const SendOutCollectionEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Send Out Collection", path: "/app/crm/sendOutCollection/list" },
    { title: "Edit Send Out Collection" },
  ];

  const {
    data: collectionDetail,
    isLoading: loadingSendOutCollection,
    error,
  } = useGetSendOutCollectionDetailQuery(id);

  const [updateSendOutCollection, { isLoading: updatingSendOutCollection }] =
    useUpdateSendOutCollectionMutation();

  const handleUpdateSendOutCollection = async (data) => {
    const _payload = { ...data, _id: id };

    try {
      await updateSendOutCollection(_payload).unwrap();
      toast.success("Send Out Collection successfully updated!");
      navigate(`/app/crm/sendOutCollection/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Send Out Collection!"
      );
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingSendOutCollection || updatingSendOutCollection}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <SendOutCollectionForm
          isBusy={loadingSendOutCollection || updatingSendOutCollection}
          collectionDetail={collectionDetail}
          onSubmit={handleUpdateSendOutCollection}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SendOutCollectionEditScreen;
